import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useClientContext } from '../../context/client_context';
import { ClientListHead } from '../_dashboard/clients';
import { loansUrl } from '../../utils/constants';
import Controls from '../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'loanRef', label: 'Loan #', alignRight: true },
  { id: 'date', label: 'Date', alignRight: true },
  { id: 'amount', label: 'Amount', alignRight: true },
  { id: 'payment', label: 'Payment', alignRight: true },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'ref', label: 'Ref', alignRight: false },
  { id: 'arrears', label: 'Arrears', alignRight: true },
  { id: 'balance', label: 'Balance', alignRight: true }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

const initialLoanApp = {
  loanList: [],
  clientName: null,
  idNumber: null,
  clientRefId: 0,
  recordTotal: 0,
  applicationRefId: 0,
  hasBridgeJob: true,
  bridgeJobRefId: 0,
  loanApplicationStatus: 1,
  loanApplicationDescription: '',
  allocatedTo: 'Un-Allocated',
  lastActionDate: '',
  createdDate: '',
  originationSourcesName: 'Internal',
  replyStatus: 0,
  replyMessage: '',
  uniqueIdentifier: null,
  transactionRef: 0
};

export default function LoansPortfolio() {
  const { currentClient } = useClientContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [loanPortfolio, setPortfolio] = useState(initialLoanApp);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    if (currentClient.cif_number > 0) getClientPortfolio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // if (currentClient.cif_number > 0) getClientPortfolio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient]);

  const getClientPortfolio = () => {
    axios(
      `${loansUrl}/api/Client/GetClientLoanPortfolio?ecNumber=${currentClient.memberShipNo}`
    ).then(
      (res) => {
        console.log('res portfolio', res);
        if (res.data.loanList === undefined || res.data.loanList === null) {
          console.log('no data returned');
          setPortfolio(initialLoanApp);
        } else {
          setPortfolio(res.data);
        }
        // setPortfolio(res.data);
      },
      (error) => {
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const openView = (e) => {
  //   navigate(`/loans/loanDetails/${e}`);
  // };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - loanPortfolio.loanList.length) : 0;

  const filteredUsers = applySortFilter(
    loanPortfolio.loanList,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={loanPortfolio.loanList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                // onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const {
                      refId,
                      loanEffective,
                      presentValue,
                      instalmentValue,
                      statusName,
                      fieldReference,
                      arrears,
                      currentBalance
                    } = row;
                    const isItemSelected = selected.indexOf(refId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={refId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{refId}</TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {moment(loanEffective).isValid()
                            ? moment(loanEffective).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="right">{presentValue.toFixed(2)}</TableCell>
                        <TableCell align="right">{instalmentValue.toFixed(2)}</TableCell>
                        <TableCell align="left">{statusName}</TableCell>
                        <TableCell align="left">{fieldReference}</TableCell>
                        <TableCell align="right">{arrears.toFixed(2)}</TableCell>
                        <TableCell align="right">{currentBalance.toFixed(2)}</TableCell>
                        {/* 
                        <TableCell align="right">
                          <IconButton onClick={() => handleLoanView({ refId })}>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell> */}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[4, 8, 12]}
          component="div"
          count={loanPortfolio.loanList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
